var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RoutinesForm',{attrs:{"routines-prop":_vm.routines,"subject-permission":_vm.subjectPermission},on:{"save-routine":_vm.saveConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }